export const INIT = 'POST_MESSAGES:INIT';
export const MESSAGE = 'POST_MESSAGES:MESSAGE';